import { UrlSanitizer } from '../../url-sanitizer';
/**
 * A builder for creating the page object for the data layer
 */
export class DataLayerPageBuilder {
    urlSanitizer;
    attributes;
    pageInfo;
    category;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(urlSanitizer) {
        this.urlSanitizer = urlSanitizer;
    }
    /**
     * Creates a new instance of the page builder with an optional url sanitizer
     * The default one is an email and vin sanitizer
     * @returns {DataLayerPageBuilder} a page builder
     */
    static new(urlSanitizer = new UrlSanitizer()) {
        return new DataLayerPageBuilder(urlSanitizer);
    }
    /**
     * Specifies the page attributes which should be part of the page object
     * @param {PageAttributes} pageAttributes the desired attributes
     * @returns {DataLayerPageBuilder} the page builder
     */
    withPageAttributes(pageAttributes) {
        this.attributes = {
            ...pageAttributes,
            architecture: 'oneAudi OS',
        };
        return this;
    }
    /**
     * Specifies the page info which should be part of the page object and sanitizes it's urls
     * @param {PageInfo} pageInfo the desired page info
     * @returns {DataLayerPageBuilder} the page builder
     */
    withPageInfo(pageInfo) {
        this.pageInfo = {
            ...pageInfo,
            destinationURL: this.urlSanitizer.sanitizeUrl(pageInfo.destinationURL) ?? '',
            referringURL: this.urlSanitizer.sanitizeUrl(pageInfo.referringURL) ?? '',
            pageID: this.urlSanitizer.sanitizeUrl(pageInfo.pageID) ?? '',
        };
        return this;
    }
    /**
     * Specifies the page category which should be part of the page object
     * @param {PageCategory} pageCategory the desired page category
     * @returns {DataLayerPageBuilder} the page builder
     */
    withPageCategory(pageCategory) {
        this.category = pageCategory;
        return this;
    }
    /**
     * Builds the page for the data layer which the specified parts.
     * If there are parts (PageCategory, PageInfo, PageAttributes) missing it will return undefined instead.
     * @returns {DataLayerPage} or undefined if information is missing
     */
    build() {
        if (this.attributes && this.pageInfo && this.category) {
            return {
                category: this.category,
                pageInfo: this.pageInfo,
                attributes: this.attributes,
            };
        }
        // eslint-disable-next-line no-console
        console.warn(`Some parts of the page object are not configured.\n
    PageInfo:\n${JSON.stringify(this.pageInfo)}\n
    PageCategory:\n${JSON.stringify(this.category)}\n
    PageAttributes:\n${JSON.stringify(this.attributes)}`);
        return undefined;
    }
}
